import {Gerarchia} from '../../+anagrafica/gerarchia/gerarchia.model';
import {TreeView} from '../../+anagrafica/gerarchia-tree/tree-view/model/tree-view-default.model';
import {Base} from './base.model';


export class Legend {

  constructor(public icon: string,  public entity: Base) {}

  /**
   * Legenda tipi entità organizzative date le gerarchia.
   * @param {Gerarchia[]} list
   * @returns {Legend[]}
   */
  public static legendForGerarchia(list: Gerarchia[]): Legend[] {
    const map: Map<number, Legend> = new Map();

    list.forEach( (item) => {

      if (item.padre && !map.get(item.padre.tipo.getId())) {
        map.set(item.padre.tipo.getId(), new Legend('cube', item.padre.tipo));
      }

      if (item.figlio && !map.get(item.figlio.tipo.getId())) {
        map.set(item.figlio.tipo.getId(), new Legend('cube', item.figlio.tipo));
      }

    });

    return Array.from(map.values());
  }

  /**
   * Legenda tipi entità organizzative dato un tree.
   * @param {Gerarchia[]} list
   * @returns {Legend[]}
   */
  public static legendForTree(tree: TreeView): Legend[] {

    const map: Map<number, Legend> = new Map();

    // costruire la lista
    tree.getNodes().forEach( (node) => {
      this.handleNode(node, map);
    });

    return Array.from(map.values());
  }

  private static handleNode(node, map: Map<number, Legend>) {
    if (node.entity && !map.get(node.entity.tipo.getId())) {
      map.set(node.entity.tipo.getId(), new Legend('cube', node.entity.tipo));
    }
    node.getChildren().forEach( (child) => this.handleNode(child, map));
  }


}
